module.exports = __webpack_public_path__ + "static/media/10 Horse Collar Grip.742c05dc.jpg";